import { createFileRoute } from '@tanstack/react-router';

import { InGameCommStyleStep } from '@/features/onboarding/components/steps/lf/inGameCommStyleStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/in-game-comm-style',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <InGameCommStyleStep />;
}
